import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from "@angular/material";
import { MessageComponent } from '../../utilities/mesagge/message.component';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class MessageService {

  dialogConfig: MatDialogConfig = new MatDialogConfig();
  settings: any;
  time: number = 3000;

  constructor(private dialog: MatDialog) {
    this.dialogConfig.disableClose = true;
    this.dialogConfig.autoFocus = false;
    this.dialogConfig.hasBackdrop = false;
    this.dialogConfig.closeOnNavigation = false;
    this.dialogConfig.position = { bottom: '10px', 'right': '10px' };
  }

  success(title: string, message: string, params?: any, time?: number, areValues?: boolean) {
    this.dialogConfig.panelClass = "dialog-success";
    this.openDialog(title, message, params, time, areValues);
  }

  error(title: string, message: any, params?: any, time?: number, areValues?: boolean) {
    this.dialogConfig.panelClass = "dialog-error";
    this.openDialog(title, message, params, time, areValues);
  }

  handleError(err: any, time?: number) {
    let message: string = "GENERAL.MESSAGE.ERROR_MESSAGE";
    let headerCodeMessage = "GENERAL.ERROR.";
    let params;
    let areValues = false;
    if (err instanceof HttpErrorResponse) {
      if (err.error) {
        if (err.error.message) {
          message = err.error.message;
        }

        if (err.error.code) {
          message = headerCodeMessage + err.error.code;
        }

        if (err.error.values) {
          params = err.error.values;
          areValues = true;
        }
      }
    }

    this.dialogConfig.panelClass = "dialog-error";
    this.openDialog('Error', message, params, time, areValues);
  }

  warning(title: string, message: string, params?: any, time?: number, areValues?: boolean) {
    this.dialogConfig.panelClass = "dialog-warning";
    this.openDialog(title, message, params, time, areValues);
  }

  openDialog(title: string, message: string, params: any, time: number, areValues: boolean) {
    this.settings = {
      title: title,
      message: message,
      params: params,
      areValues: areValues
    }

    this.dialogConfig.data = this.settings;
    let dialogRef = this.dialog.open(MessageComponent, this.dialogConfig);
    setTimeout(() => {
      dialogRef.close();
    }, time ? time : this.time);
  }


}
